import React from "react";
import { PairwisePoster, pairwiseMovieMetadata } from "./PairwiseMoviePresentation";

export function normalizeCommonMovie(movie = {}) {
  return {
    id: movie.imdb_tconst ?? movie.movieId,
    title: movie.title ?? "Movie",
    poster: movie.poster ?? movie.poster_path ?? "",
    year: movie.year ?? null,
    runtime: movie.runtime ?? null,
    genres: movie.genres ?? movie.genre ?? "",
    overview: movie.overview ?? movie.plot ?? "",
  };
}

export default function CommonMovieCard({ movie, compact = false }) {
  const item = normalizeCommonMovie(movie);
  const details = compact
    ? [item.year].filter(Boolean).join(" • ")
    : pairwiseMovieMetadata({ year: item.year, genre: item.genres, runtime: item.runtime });
  return (
    <article className={`common-movie-card${compact ? " common-movie-card--compact" : ""}`}>
      <PairwisePoster movie={{ ...item, posterPath: item.poster }} width={compact ? 150 : 200} height={compact ? 225 : 300} />
      <h3>{item.title}</h3>
      {details && <p className="common-movie-meta">{details}</p>}
      {!compact && item.overview && <p className="common-movie-overview">{item.overview}</p>}
    </article>
  );
}
